import Vue from 'vue'
import Element from 'element-ui'
import '../element-variables.scss'
// import '../theme/element-#141C23/index.css'

Vue.use(Element)
